import { ArrowButton } from './ArrowButton';
import { useNavigate } from 'react-router-dom';
export function AccessRect() {
  const navigate = useNavigate();
  
  const handleClick = () => {
    navigate('/inner-page');
  }
  return (
    <div className="container container-max-w mx-auto py-[35px] px-[40px] h-[253px] bg-[url('@/assets/images/access-bg.png')] text-white mb-[120px] mt-[40px]" >
      <div className="text-[32px]">Seamless access</div> 
      <div className="text-[#cfcfcf]">test and acquire datasets from iData</div> 
      <div className="mb-[26px] text-[#cfcfcf]">providers at iData’s self-service data website.</div> 
      <ArrowButton text={'iData Go!'} className="w-[160px] h-[52px] text-[24px] font-bold" onClick={handleClick}
      textClassName="mr-[5px]" arrowClassName="w-[20px] h-[20px]"></ArrowButton>
    </div>
  )
}